import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import autoBind from 'react-autobind';

import styles from './index.module.scss';
import Header from './header';
import Footer from './footer';
import Flash from 'ui/common/flash';

import { addMessage } from 'store/features/common/flash/actions';
import { messageTypes } from 'store/features/common/flash/builder';
import routeTemplates from 'ui/common/routes/templates';
import { createMatchSelector } from 'ui/common/routes/selectors';

import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { resultHasErrors, errorsToSingleMessage } from 'utils/graphql-errors';
import { isEqual } from 'lodash';
import {
  selectIsFetchingCompanies,
  selectMyCompanies,
} from 'store/graphql/AdminFetchMyCompanies/selectors';

import { detect } from 'detect-browser';
import {
  selectCurrentUser,
  selectCurrentUserInitialized,
  selectIsLoggedIn,
} from 'store/features/auth/selectors';
import { fetchMyCompanies } from 'store/graphql/AdminFetchMyCompanies/actions';

import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import AdminFetchMyCompaniesReducer from 'store/graphql/AdminFetchMyCompanies/reducer';

const {
  start: fetchMyCompaniesStart,
  success: fetchMyCompaniesSuccess,
  failure: fetchMyCompaniesFailure,
} = fetchMyCompanies;

const browser = detect();

class Layout extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  static propTypes = {
    intl: intlShape,
  };

  componentDidMount() {
    this.fetchMyCompanies();

    const { addMessage } = this.props;

    if (browser.name === 'edge' || browser.name === 'ie') {
      addMessage({
        kind: messageTypes.danger,
        content: 'We do not support IE, Please use either Chrome or Firefox',
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.currentUser &&
      nextProps.currentUserInitialized &&
      !isEqual(this.props.currentUser.myCompanies, nextProps.currentUser.myCompanies)
    ) {
      this.fetchMyCompanies(nextProps);
    }
  }

  async fetchMyCompanies() {
    const {
      client,
      fetchMyCompaniesStart,
      fetchMyCompaniesSuccess,
      fetchMyCompaniesFailure,
      isFetchingCompanies,
    } = this.props;
    if (isFetchingCompanies) return;
    fetchMyCompaniesStart();
    try {
      const result = await client.query({
        query: gql`
          query getMyCompanies {
            getMyCompanies {
              id
              companyName
              prettyId
              features {
                magicLink
                partnerClaims
                profiler
              }
              profilerRunId
              acl {
                user {
                  _id
                  username
                  name
                }
              }
            }
          }
        `,
      });

      const { data, errors } = result;
      // Temporary hot fix, only errors if data.getMyCompanies is null
      if (resultHasErrors({ errors }) && !((data || {}).getMyCompanies || []).length) {
        fetchMyCompaniesFailure({ errors: errorsToSingleMessage({ errors }) });
      } else {
        const { getMyCompanies } = result.data;

        fetchMyCompaniesSuccess({
          result: {
            myCompanies: getMyCompanies,
          },
        });
      }
    } catch (error) {
      fetchMyCompaniesFailure({ errors: error.message });
    }
  }

  render() {
    const { invertedFooter, myCompanies } = this.props;
    return (
      <div className={classnames(styles.layout)}>
        <Header companies={myCompanies} className={classnames(styles.header)} />
        <div className={styles.content}>
          <div className={styles.flashWrapper}>
            <Flash className="container mt-3" />
          </div>
          {this.props.children}
        </div>
        <Footer inverted={invertedFooter} />
      </div>
    );
  }
}

const rootMatchSelecter = createMatchSelector({ path: routeTemplates.root, exact: true });
const aboutCompanyMatchSelecter = createMatchSelector({
  path: routeTemplates.aboutCompany,
  exact: true,
});

const claimsNewSelector = createMatchSelector({ path: routeTemplates.claims.new, exact: true });

function mapStateToProps(state, ownProps) {
  const rootMatch = rootMatchSelecter(state);
  const aboutCompanyMatch = aboutCompanyMatchSelecter(state);
  const claimsNewMatch = claimsNewSelector(state);

  return {
    invertedFooter: !!rootMatch || !!aboutCompanyMatch || !!claimsNewMatch,
    isLoggedIn: selectIsLoggedIn(state),
    isFetchingCompanies: selectIsFetchingCompanies(state),
    myCompanies: selectMyCompanies(state),
    currentUser: selectCurrentUser(state),
    currentUserInitialized: selectCurrentUserInitialized(state),
  };
}

const mapDispatchToProps = {
  fetchMyCompaniesStart,
  fetchMyCompaniesSuccess,
  fetchMyCompaniesFailure,
  addMessage,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withAdminFetchMyCompaniesReducer = injectReducer({
  key: 'AdminFetchMyCompanies',
  reducer: AdminFetchMyCompaniesReducer,
});

export default withRouter(
  compose(withAdminFetchMyCompaniesReducer, withConnect)(injectIntl(withApollo(Layout)))
);



// WEBPACK FOOTER //
// ./src/ui/app/layout/index.js